import React from 'react';
import Image from '../../Components/Image/Image';
import { useDispatch, useSelector } from 'react-redux';
import { setThumbnailImage } from '../slice';
import { useSingleImageEffect } from '@/src/components/Upload';

const ImageSection = (props) => {
  const thumbnailImage = useSelector(
    (state: any) => state.productSet.thumbnailImage,
  );

  const [fileList, setFileList] = React.useState(
    thumbnailImage ? [thumbnailImage] : [],
  );
  useSingleImageEffect(thumbnailImage, fileList, setFileList);
  const dispatch = useDispatch();
  const onChange = (img) => {
    dispatch(setThumbnailImage(img));
  };
  return (
    <Image
      onChange={onChange}
      fileList={fileList}
      disabled={props.disabled}
      //thumbnailImage={thumbnailImage}
      setFileList={setFileList}
    />
  );
};
export default ImageSection;
